<template>
  <header>
    <v-app-bar app flat color="white" style="top: inherit !important">
      <v-app-bar-nav-icon
        class="mr-4"
        @click="$vuetify.breakpoint.mdAndUp ? (mini = !mini) : (drawer = !drawer)"
      ></v-app-bar-nav-icon>

      <v-btn
        :color="paymentsLevel === 1 ? 'yellow' : paymentsLevel === 2 ? 'orange' : 'red'"
        class="text-capitalize white--text"
        depressed
        v-text="pendingPaymentsText[lang]"
        v-if="paymentsLevel !== 4"
        @click="$router.push(`/${lang}/storePanel/transactions`)"
      ></v-btn>

      <v-spacer></v-spacer>

      <template class="ml-4">
        <div>
          <v-icon v-text="icons.mdiPhone"></v-icon>
          {{ phoneNumber }}
        </div>
      </template>

      <b-lang-menu v-model="lang"></b-lang-menu>

      <v-tooltip color="secondary" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="helpDialog = true">
            <v-icon v-text="icons.mdiHelpCircleOutline"></v-icon>
          </v-btn>
        </template>

        <span class="font-weight-bold">Help</span>
      </v-tooltip>

      <!-- <AppNotifications /> -->

      <v-menu offset-y transition="slide-y-transition" nudge-bottom="2">
        <template v-slot:activator="{ on }">
          <v-btn class="text-capitalize" height="50" text v-on="on">
            <v-row no-gutters align="center">
              <v-col cols="auto">
                <v-avatar size="32">
                  <v-img :src="user.avatar"></v-img>
                </v-avatar>
              </v-col>

              <v-col cols="auto" class="ml-1 mr-2">
                <div>
                  {{ user.full_name }}
                </div>
                <small class="green--text">{{ user.role }}</small>
              </v-col>

              <v-col cols="auto">
                <v-icon v-text="icons.mdiChevronDown"></v-icon>
              </v-col>
            </v-row>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item color="blue" @click="switchAccount()">
            <v-list-item-icon class="mr-3">
              <v-icon color="blue" v-text="icons.mdiAccount"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="blue--text">{{
              translations.profile[lang]
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item color="red" @click="logout">
            <v-list-item-icon class="mr-3">
              <v-icon style="margin-left: 2px" color="red" v-text="icons.mdiLogout"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="red--text">{{ translations.logout[lang] }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text icon @click.stop="rightDrawer = !rightDrawer">
        <CustomSvg />
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      app
      color="secondary"
      v-model="drawer"
      :mini-variant="mini"
      mini-variant-width="80"
      :temporary="$vuetify.breakpoint.smAndDown"
      :permanent="$vuetify.breakpoint.mdAndUp"
      dark
      style="top: inherit !important"
    >
      <v-list-item href="https://www.roadcube.com" class="d-block pa-3 home-link">
        <v-img src="../assets/home/logo.png" class="mx-auto" width="70%" contain></v-img>
      </v-list-item>

      <v-divider></v-divider>

      <v-row class="pt-4 pb-3" no-gutters justify="center">
        <v-sheet light class="pa-2 rounded-circle">
          <v-skeleton-loader
            :loading="loading"
            type="image"
            width="50"
            height="50"
            class="rounded-circle"
          >
            <v-img :src="logo" width="50" height="50" contain class="rounded-circle"></v-img>
          </v-skeleton-loader>
        </v-sheet>

        <v-col cols="12" class="text-center mt-3">
          <v-skeleton-loader v-if="loading" type="heading" class="mx-5"></v-skeleton-loader>
          <p v-else class="white--text" :class="mini ? 'small-text' : 'subtitle-1'">
            {{ storeName }}
          </p>
        </v-col>

        <v-col cols="12" class="text-center mt-3">
          <v-btn class="ma-2 text-capitalize" outlined depressed small @click="storesModal = true">
            <v-icon v-text="icons.mdiSync" />
            {{ changeStore[lang] }}
          </v-btn>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-container class="pa-0 pb-16 mb-16" :style="{ height: containerHeight, overflow: 'auto' }">
        <v-list
          v-for="navLink in navLinks"
          :key="navLink.title['en']"
          dense
          nav
          :subheader="navLink.title['en'] !== 'MANAGE'"
        >
          <v-subheader
            class="text-caption"
            :class="{ 'justify-center': mini }"
            v-text="navLink.title[lang]"
          ></v-subheader>

          <div v-for="item in navLink.children" :key="item.title['en']">
            <v-tooltip v-if="mini" color="secondary" right>
              <template v-slot:activator="{ on }">
                <v-list-item v-if="!item.hide" :to="item.to" :exact="item.exact" v-on="on">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="item.title[lang]"></v-list-item-title>
                </v-list-item>
              </template>

              <span class="font-weight-bold" v-text="item.title[lang]"></span>
            </v-tooltip>

            <v-list-item v-else-if="!item.hide" :to="item.to" :exact="item.exact">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-title v-text="item.title[lang]"> </v-list-item-title>
            </v-list-item>
          </div>
        </v-list>

        <!-- <v-divider v-if="companyName == 'Cardlink'"></v-divider>

                <v-list>
                    <v-list-item class="details-item">
                        Τηλ. Εξυπηρέτησης:
                    </v-list-item>
                    <v-list-item class="details-item">
                        210 6303000
                    </v-list-item>
                    <v-list-item class="details-item">
                        Ωράριο Εξυπηρέτησης:
                    </v-list-item>
                    <v-list-item class="details-item">
                        <li>Δευ-Παρ: 07:00 π.μ. - 00:00 μ.μ.</li>
                    </v-list-item>
                    <v-list-item class="details-item">
                        <li>Σαβ: 08.00 π.μ. - 22:00 μ.μ.</li>
                    </v-list-item>
                    <v-list-item class="details-item">
                        <li>Κυρ: 11:00 π.μ. - 20.00 μ.μ. εκτός αργιών</li>
                    </v-list-item>
                </v-list> -->
      </v-container>
    </v-navigation-drawer>

    <GeneralSettings v-model="rightDrawer" />

    <v-dialog v-model="helpDialog" max-width="500">
      <b-card
        title="Help"
        @cancel="helpDialog = false"
        :submitBtn="false"
        :cancel-text="{ el: '', en: 'Close', it: '' }"
      >
        <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
          <v-icon v-text="icons.mdiPhone"></v-icon>
          {{ phoneNumber }}
        </v-sheet>

        <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
          <v-icon v-text="icons.mdiEmail"></v-icon>
          {{ emailAddress }}
        </v-sheet>
      </b-card>
    </v-dialog>

    <v-dialog v-model="storesModal" max-width="500">
      <b-card
        :title="storeModalTitle[lang]"
        :loading="loading"
        @cancel="storesModal = false"
        @submit="connectStore()"
        :cancel-text="{ el: 'Κλείσιμο', en: 'Close', it: 'Chiudi' }"
        :submit-text="{ el: 'Σύνδεση', en: 'Connect', it: 'Collegare' }"
      >
        <v-col cols="12" class="d-flex justify-center">
          <UserStoresSelect v-model="storeSelect" :loading="loading" />
        </v-col>
      </b-card>
    </v-dialog>
  </header>
</template>

<script>
import storePanel from '@/store/modules/storePanel';
import UserStoresSelect from '@/components/general/UserStoresSelect.vue';
import translations from '@/utils/translations/global';
import CustomSvg from '@/components/general/CustomSvg.vue';
import GeneralSettings from '@/components/general/settings';

import {
  mdiHelpCircleOutline,
  mdiChevronDown,
  mdiBellOutline,
  mdiLogout,
  mdiAccount,
  mdiPhone,
  mdiEmail,
  mdiSync,
  mdiMenuUp,
  mdiMenuDown,
  mdiClose,
  mdiCashMultiple,
} from '@mdi/js';

import navLinks from '@/utils/storePanel/navLinks';
import { mapActions, mapMutations, mapState } from 'vuex';
import API from '@/models/API';
import Pusher from 'pusher-js';

export default {
  name: 'StoreHeader',

  components: { UserStoresSelect, CustomSvg, GeneralSettings },

  // components: { AppNotifications },

  mixins: [navLinks, translations],

  data() {
    return {
      icons: {
        mdiHelpCircleOutline,
        mdiChevronDown,
        mdiBellOutline,
        mdiLogout,
        mdiAccount,
        mdiPhone,
        mdiEmail,
        mdiSync,
        mdiMenuUp,
        mdiMenuDown,
        mdiClose,
        mdiCashMultiple,
      },
      mini: false,
      drawer: false,
      helpDialog: false,
      phoneNumber: '210 300 6633',
      emailAddress: 'support@roadcube.com',
      paymentsInterval: null,
      pendingPaymentsText: {
        el: 'Συναλλαγές σε Εκκρεμότητα',
        en: 'Pending Transactions',
        it: 'Transazioni Pendenti',
      },
      changeStore: {
        el: 'Άλλαξε Κατάστημα',
        en: 'Change Store',
        it: 'Cambia Negozio',
      },
      storeModalTitle: {
        el: 'Επίλεξε κατάστημα ή επιχείρηση:',
        en: 'Select store or company:',
        it: "Seleziona il negozio o l'azienda:",
      },
      storesModal: false,
      closeMenu: false,
      storeSelect: null,
      rightDrawer: false,
    };
  },

  computed: {
    ...mapState(['user', 'storeId']),
    ...mapState('storePanel', ['paymentsLevel']),

    lang: {
      get() {
        return this.$route.params.lang;
      },

      set(val) {
        if (val !== this.$route.params.lang)
          this.$router.push(`/${val}/` + this.$route.fullPath.slice(4));
      },
    },

    loading() {
      return this.$store.state.storePanel.loading;
    },

    user() {
      return this.$store.state.user;
    },

    logo() {
      return this.$store.state.storePanel.store.logo;
    },

    storeName() {
      return this.$store.state.storePanel.store.app_name;
    },

    companyName() {
      return this.$store.state.storePanel.store.company.app_name;
    },

    containerHeight() {
      return this.mini ? 'calc(100vh - 194px)' : 'calc(100vh - 184px)';
    },

    paymentError() {
      return this.$store.state.storePanel.paymentError;
    },
  },

  methods: {
    ...mapActions(['changeLanguage', 'newNotification', 'getUser']),
    ...mapActions('storePanel', ['getPandingPayments', 'getStore']),
    ...mapActions('loyaltyPanel', ['getCompany']),
    ...mapMutations(['setStoreId', 'setAccessToken']),
    ...mapMutations('storePanel', ['setLoading']),

    async logout() {
      try {
        const { data } = await API.post(`/users/logout`);

        localStorage.removeItem('storeId');
        localStorage.removeItem('companyId');
        localStorage.removeItem('accessToken');
        this.setAccessToken('');
        window.location = 'https://RoadCube.com';
      } catch (ex) {
        this.$router.push(`/${this.lang}/`);
        console.log(ex.response.data);
      }
    },

    switchAccount() {
      this.$router.push({ name: 'UserStores' });
    },

    async connectStore() {
      try {
        this.setLoading(true);
        localStorage.setItem('storeId', this.storeSelect.store_id);
        this.setStoreId(this.storeSelect.store_id);
        await this.getUser(this.storeSelect.store_id);
        if (this.storeSelect.store_type_id === 1) {
          await this.getCompany();
          this.$router.push(`/${this.lang}/loyaltyPanel`);
        } else if (this.storeSelect.store_type_id === 2) {
          await this.getStore();
          this.$router.push(`/${this.lang}/storePanel`);
        } else if (this.storeSelect.store_type_id === 3) {
          this.$router.push(`/${this.lang}/supplierPanel/send-reports/pending`);
        }
      } catch (ex) {
        this.setLoading(false);
        this.errorMessage = ex.response.data.message;
        setTimeout(() => (this.errorMessage = ''), 5000);
      }
      this.storesModal = false;
    },
  },

  mounted() {
    this.getPandingPayments();
    this.paymentsInterval = window.setInterval(() => {
      this.getPandingPayments();
    }, 1800000);
  },

  beforeDestroy() {
    clearInterval(this.paymentsInterval);
  },

  watch: {
    lang(val) {
      let body = {
        language_id: val == 'en' ? 1 : val == 'el' ? 2 : 3,
      };

      this.changeLanguage(body);
    },
  },

  beforeCreate() {
    if (!this.$store.hasModule('storePanel')) this.$store.registerModule('storePanel', storePanel);
  },
};
</script>

<style>
.v-skeleton-loader__heading {
  width: 100% !important;
}

.small-text {
  font-size: 10px;
}
</style>

<style scoped>
.home-link:hover {
  background-color: #1bbae1 !important;
}

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #555;
}

.details-item {
  min-height: 20px !important;
}
</style>
